import React from "react";

const Year = () => {
  const today = new Date();
  const year = today.getFullYear();
 
  return (
    <>
      {year}
    </>
  );
 };
 
 export default Year;